import Axios from 'axios'

// I think this can be part of the gameScene
export default class InteractiveLayer {
    // TODO: is this the right type?
    element: SVGSVGElement

    constructor(interactiveLayerSVG: SVGSVGElement) {
        this.element = interactiveLayerSVG
    }

    static load = async (url: string) => {
        const response = await Axios.get<Document>(url, { responseType: 'document' })
        // TODO: validate SVG?
        const svg = response.data.firstChild as SVGSVGElement

        return new InteractiveLayer(svg)
    }

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    destroy = () => {
        this.element.remove()
    }
}
